
import { BehaviorSubject, fromEvent, merge, Subscription, timer } from 'rxjs';
import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { ActiveToast } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
@Injectable({
  providedIn: 'root'
})
export class SearchService {
  private searchQuery = new BehaviorSubject<string>(''); // Stores search query globally
  searchQuery$ = this.searchQuery.asObservable(); // Observable to listen for changes
private toastRef?: ActiveToast<any>;
  setSearchQuery(query: string) {
    this.searchQuery.next(query);
  }
  private activity$ = merge(
    fromEvent(document, 'mousemove'),
    fromEvent(document, 'click'),
    fromEvent(document, 'keydown'),
    fromEvent(document, 'scroll'),
    fromEvent(document, 'touchstart')
  );

  private idleTimerSub?: Subscription;
  private activitySub?: Subscription;

private get idleMs(): number {
    const idle = Number(sessionStorage.getItem('IdleTimeoutMinutes')) || 15;
    return idle * 60 * 1000;
  }

  private popupEl?: HTMLElement;

  constructor(
  private dialog: MatDialog,
    private router: Router,
    private ngZone: NgZone
  ) {}
private isTokenActive(): boolean {
  const token = sessionStorage.getItem('authToken'); // change key if needed
  if (!token) return false;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return Date.now() < payload.exp * 1000;
  } catch {
    return false;
  }
}

start() {
    if (!this.isTokenActive()) {
      return;
    }
    // Prevent duplicate subscription
    if (this.activitySub) return;

    // Activity listener
    this.ngZone.runOutsideAngular(() => {
      this.activitySub = this.activity$.subscribe(() => {
        // Update shared activity timestamp
        localStorage.setItem('lastActivity', Date.now().toString());
        this.reset();
      });
    });

    // Initialize shared timestamp on start
    localStorage.setItem('lastActivity', Date.now().toString());

    this.listenToOtherTabs();   // ← this line was missing, method was never called

    this.reset();
  }


      private tabListenerAttached = false;

    private listenToOtherTabs() {
    if (this.tabListenerAttached) return;
    this.tabListenerAttached = true;
    window.addEventListener('storage', (event) => {
      if (event.key === 'lastActivity') {
        // Another tab performed activity → reset idle timer
        this.reset();
      }
    });
  }
 private reset() {
 
    this.idleTimerSub?.unsubscribe();
    this.removePopup();

    const warningMs = 1 * 60 * 1000; // show warning at last 1 minute

    this.idleTimerSub = timer(0, 1000).subscribe(() => {
      const lastActivity = Number(localStorage.getItem('lastActivity')) || Date.now();
      const now = Date.now();
      const timeLeft = (this.idleMs - (now - lastActivity)) / 1000;

      // Show popup
      if (timeLeft <= warningMs / 1000 && timeLeft > 0) {
        this.ngZone.run(() => this.showPopup(timeLeft));
      }

      // Final logout
      if (timeLeft <= 0) {
        this.ngZone.run(() => {
          this.removePopup();
          this.timeout();
        });

        this.idleTimerSub?.unsubscribe();
      }
    });
  }
  private showPopup(secondsLeft: number) {
  if (!this.popupEl) {
    // Create overlay
    const overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.background = 'rgba(0,0,0,0.3)';
    overlay.style.zIndex = '9998';
    overlay.id = 'idle-popup-overlay';
    document.body.appendChild(overlay);

    // Create popup container
    this.popupEl = document.createElement('div');
    this.popupEl.style.position = 'fixed';
    this.popupEl.style.top = '50%';
    this.popupEl.style.left = '50%';
    this.popupEl.style.transform = 'translate(-50%, -50%)';
    this.popupEl.style.background = '#fff';
    this.popupEl.style.padding = '30px 40px';
    this.popupEl.style.borderRadius = '10px';
    this.popupEl.style.boxShadow = '0 4px 12px rgba(0,0,0,0.25)';
    this.popupEl.style.zIndex = '9999';
    this.popupEl.style.textAlign = 'center';
    this.popupEl.style.minWidth = '300px';

    // Title
    const title = document.createElement('h2');
    title.innerText = 'Session Expiring';
    title.style.marginBottom = '10px';
    this.popupEl.appendChild(title);

    // Message
    const msg = document.createElement('p');
    msg.innerText = 'Your session will end soon due to inactivity.';
    msg.style.marginBottom = '20px';
    this.popupEl.appendChild(msg);

    // Countdown
    const countdown = document.createElement('div');
    countdown.id = 'idle-countdown';
    countdown.innerText = this.formatTime(secondsLeft);
    countdown.style.fontSize = '2rem';
    countdown.style.color = 'red';
    countdown.style.marginBottom = '20px';
    this.popupEl.appendChild(countdown);

    // Buttons container
    const btnContainer = document.createElement('div');
    btnContainer.style.display = 'flex';
    btnContainer.style.justifyContent = 'space-between';

    // Logout button
    const logoutBtn = document.createElement('button');
    logoutBtn.innerText = 'Logout';
    logoutBtn.style.background = 'none';
    logoutBtn.style.color = 'red';
    logoutBtn.style.border = 'none';
    logoutBtn.style.cursor = 'pointer';
    logoutBtn.style.fontSize = '1rem';
    logoutBtn.onclick = () => {
      this.removePopup();
      this.timeout();
    };

    // Stay Logged In button
    const stayBtn = document.createElement('button');
    stayBtn.innerText = 'Stay Logged In';
    stayBtn.style.background = '#0b5ed7';
    stayBtn.style.color = '#fff';
    stayBtn.style.border = 'none';
    stayBtn.style.borderRadius = '5px';
    stayBtn.style.padding = '8px 15px';
    stayBtn.style.cursor = 'pointer';
    stayBtn.onclick = () => {
      this.reset(); // reset timer
      this.removePopup();
    };

    btnContainer.appendChild(logoutBtn);
    btnContainer.appendChild(stayBtn);

    this.popupEl.appendChild(btnContainer);
    document.body.appendChild(this.popupEl);
  } else {
    // Update countdown
    const countdown = document.getElementById('idle-countdown');
    if (countdown) countdown.innerText = this.formatTime(secondsLeft);
  }
}

// Format seconds as mm:ss
private formatTime(seconds: number) {
  const m = Math.floor(seconds / 60).toString().padStart(2, '0');
  const s = Math.floor(seconds % 60).toString().padStart(2, '0');
  return `${m}:${s}`;
}

// Remove popup
private removePopup() {
  if (this.popupEl) {
    const overlay = document.getElementById('idle-popup-overlay');
    if (overlay) document.body.removeChild(overlay);
    document.body.removeChild(this.popupEl);
    this.popupEl = undefined;
  }
}

private timeout() {
  // Close all open popups
  this.dialog.closeAll();  // ⬅ closes every material dialog popup

  // Clear session
  sessionStorage.clear();

  // Navigate to login
  this.router.navigate(['/authentication/login']);
}

  stop() {
    this.idleTimerSub?.unsubscribe();
    this.activitySub?.unsubscribe();
    
    this.activitySub = undefined;
    this.removePopup();
  }
}
